import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const shortcutsSmartLinksQuery: GraphQLTaggedNode = graphql`
	query shortcutsSmartLinksQuery($spaceKey: String!, $cloudId: ID!) {
		...shortcutsSmartLinksFragment_query @relay(mask: false)
	}
`;
